export const root = "r14n1pvo";
export const rowArrowLeft = "rohqwns";
export const rowArrowRight = "rhu7vfm";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");